import React, { Component } from 'react';
import { Formik } from 'formik';
import Form from 'react-bootstrap/lib/Form';
import { LoginUserValidationSchema } from '../../../validators';
import TPLogo from '../../../images/tp.png';
import KeyLogo from '../../../images/key.png';
import IBOMLogo from '../../../images/logo_small.png';
import { ButtonLoader } from '../../ButtonLoader';
import { RouteUrls } from '../../../configs/routeUrls';

export class LoginForm extends Component {
	componentDidMount() {
		this.props.onSetBreadcrumbs([
			{
				url: RouteUrls.App.login,
				displayName: 'Logowanie'
			}
		]);
	}
	render() {
		const { applicationImages } = this.props;
		return (
			<Formik
				enableReinitialize={true}
				initialValues={{
					login: '',
					password: ''
				}}
				validationSchema={LoginUserValidationSchema}
				render={({ values, handleChange, handleBlur, isValid, errors, touched }) => (
					<Form
						onSubmit={(e) => {
							e.preventDefault();
							this.props.loginUser(values);
						}}
					>
						<section id="content" className="container signinup">
							<header className="signinup__header">
								<h1 className="signinup__title">Zaloguj się</h1>
								<div className="signinup__subtitle">
									aby móc w pełni korzystać z platformy e-Konsultacji
								</div>
							</header>
							<div className="signinup__row">
								<div className="signinup__column">
									<a
										className="icon-button"
										href={this.props.externalSystemAddress}
										title="Zaloguj się przez EBOI/IBOM"
									>
										<div className="icon-button__icon" aria-hidden="true">
											{applicationImages && (
												<img
													className="icon-button__icon-img"
													src={`data:${applicationImages.smallLogoContentType};base64,${applicationImages.smallLogo}`}
													title="Logo urzędu"
													alt="Logo urzędu"
												/>
											)}
										</div>
										<div className="icon-button__text" aria-hidden="true">
											Zaloguj się przez EBOI/IBOM
										</div>
									</a>
									{false && (
										<a
											className="icon-button"
											href="http://demo-01.ibom.pl/Account/LogInByTp"
											title="Zaloguj się przez profil zaufany"
											disabled="disabled"
											alt="Logo Profilu Zaufanego"
										>
											<div className="icon-button__icon" aria-hidden="true">
												<img src={TPLogo} alt="Logo Profilu Zaufanego" />
											</div>
											<div className="icon-button__text" aria-hidden="true">
												Zaloguj się przez profil zaufany
											</div>
										</a>
									)}
									{false && (
										<a
											className="icon-button"
											href="http://demo-01.ibom.pl/Account/LogIn#"
											title="Zaloguj się przez Certyfikat Kwalifikowany"
											disabled="disabled"
											alt="Logo Certyfikatu Kwalifikowanego"
											onClick="loadModule()"
										>
											<div className="icon-button__icon" aria-hidden="true">
												<img src={KeyLogo} alt="Logo Certyfikatu Kwalifikowanego" />
											</div>
											<div className="icon-button__text" aria-hidden="true">
												Zaloguj się przez Certyfikat Kwalifikowany
											</div>
										</a>
									)}
									{/*
                            <a className="link link--weight-300 link--top-40 row row--nowrap row--align-baseline" href="http://demo-01.ibom.pl/HelpText/GetPage/a53137a1-f4af-43b6-8072-e588891eeaa4" title="Pokaż instrukcję tworzenia konta Profilu Zaufanego" target="_blank">
                                <i className="fas fa-book link__icon link__icon-left" aria-hidden="true"></i>
                                <span aria-hidden="true">Instrukcja tworzenia konta Profilu Zaufanego</span>
                            </a>
                            */}
								</div>
								<div className="signinup__column">
									<div className="field">
										<Form.Label className="field__label" htmlFor="login">
											Adres e-mail(login)
										</Form.Label>
										<Form.Control
											className={`${!!errors.login ? 'input-validation-error' : ''} field__input`}
											id="login"
											name="login"
											title="Podaj nazwę użytkownika"
											type="text"
											value={values.login}
											onChange={handleChange}
											onBlur={handleBlur}
											isInvalid={!!errors.login}
										/>
										{errors.login && (
											<Form.Control.Feedback
												className="field-validation-error field__validation"
												type="invalid"
											>
												{errors.login}
											</Form.Control.Feedback>
										)}
									</div>
									<div className="field">
										<Form.Label className="field__label" htmlFor="password">
											Hasło
										</Form.Label>
										<input
											className={`${!!errors.password
												? 'input-validation-error'
												: ''} field__input`}
											id="password"
											name="password"
											title="Podaj hasło"
											type="password"
											value={values.password}
											onChange={handleChange}
											onBlur={handleBlur}
											isInvalid={!!errors.password}
										/>
										{errors.password && (
											<Form.Control.Feedback
												className="field-validation-error field__validation"
												type="invalid"
											>
												{errors.password}
											</Form.Control.Feedback>
										)}
									</div>
									{!this.props.isLoging && (
										<input
											type="submit"
											className="button button--primary-dark signinup__signin-button"
											value="Zaloguj"
											title="Zaloguj się"
										/>
									)}
									{this.props.isLoging && (
										<ButtonLoader
											color="#fff"
											executingText="Logowanie"
											isExecuting={this.props.isLoging}
											className={`button button--primary-dark`}
										/>
									)}
									{/*
                            <div className="signinup__forgot-password">
                                <a className="signinup__forgot-password-link" href="http://demo-01.ibom.pl/Account/ResetPassword" title="Przejdź do formularza przypominania hasła">
                                    <span>Nie pamiętasz hasła?</span>
                                </a>
                            </div>
                            <div className="signinup__signup-title">Nie masz jeszcze konta?</div>
                            <a className="button button--danger signinup__signup-button" href="http://demo-01.ibom.pl/Customer/Create" title="Przejdź do formularza rejestracji">
                                Zarejestruj się
                            </a>
                            */}
								</div>
							</div>
						</section>
					</Form>
				)}
			/>
		);
	}
}
